import { createVuetify } from 'vuetify'

import 'vuetify/styles'

export default createVuetify({
  display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 0,
      sm: 480, // Mobile
      md: 1024, // Tablet
      lg: 1600, // PC
    },
  },
})
